import React, { Component } from "react";
import _ from "lodash";
import anime from "animejs";
// import { Parallax } from "react-skrollr";
import SplitText from "react-pose-text";
import { withRedux } from "../../hoc";
import ArticleItem from "../../components/ArticleItem";
import { MyWaypoint } from "../../components";

// const leaf = "/assets/images/leaf.png";

const mapStateToProps = ({ language, t, posts }) => {
  const data = _.get(posts, "data");
  const news = _.filter(data, item => {
    const categoryID = _.get(item, "category.id");
    return categoryID === _.toNumber(process.env.REACT_APP_POST_NEWS_ID);
  });

  const orderNews = _.sortBy(news, "updated_at");

  return {
    language,
    t,
    news: _.slice(orderNews, 0, 3)
  };
};

const actionToProps = {};

@withRedux(mapStateToProps, actionToProps)
export default class Section5 extends Component {
  render() {
    const { news } = this.props;
    return (
      <div className="section-5">
        {/* <div className="container-parallax-feather-left">
          <Parallax
            data={{
              "data-bottom-center": "transform: translateY(100px);",
              "data-center-top": "transform: translateY(0px);"
            }}
          >
            <Image className="leaf" src={leaf} alt="" />
          </Parallax>
        </div> */}
        <div className="container">
          <MyWaypoint>
            <div className="title">
              <h2>
                <SplitText
                  initialPose="exit"
                  pose="enter"
                  charPoses={{
                    exit: { opacity: 0, scale: 0 },
                    enter: {
                      opacity: 1,
                      scale: 1,
                      transition: ({ charInWordIndex }) => ({
                        type: "spring",
                        delay: charInWordIndex * 60,
                        stiffness: 150,
                        damping: 40
                      })
                    }
                  }}
                >
                  What’s News
                </SplitText>
              </h2>
            </div>
          </MyWaypoint>
          <div className="container-article">
            <MyWaypoint
              anime={[
                () =>
                  anime({
                    targets: ".section-5 .container-article .container-article-item .container-img",
                    opacity: [0, 1],
                    translateY: [10, 0],
                    easing: "easeInOutSine",
                    duration: 1000,
                    delay: (el, i) => {
                      return 300 + i * 100;
                    }
                  }),
                () =>
                  anime({
                    targets: ".section-5 .container-article .container-article-item .article-title",
                    opacity: [0, 1],
                    translateY: [10, 0],
                    easing: "easeInOutSine",
                    duration: 1000,
                    delay: (el, i) => {
                      return 600 + i * 100;
                    }
                  }),
                () =>
                  anime({
                    targets: ".section-5 .container-article .container-article-item .article-content",
                    opacity: [0, 1],
                    translateY: [10, 0],
                    easing: "easeInOutSine",
                    duration: 1000,
                    delay: (el, i) => {
                      return 900 + i * 100;
                    }
                  })
              ]}
            >
              <div className="row">
                {_.map(news, (item, key) => {
                  return (
                    <div className="col-md-4" key={key}>
                      <div className="container-article-item">
                        <ArticleItem data={item} pathOnClick={`/news/detail/${_.get(item, "id")}`} />
                      </div>
                    </div>
                  );
                })}
              </div>
            </MyWaypoint>
          </div>
        </div>
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./src/pages/Home/Section5.js